/**
 * Shared field rules for the identity forms.
 *
 * These mirror the api rules in app/Domains/Shared/Rules. They lived inline in
 * four separate forms and had drifted apart, so a value one form accepted the
 * api then rejected — which is how the postal code and landline bugs reached
 * users. Keep both sides in step when changing anything here.
 */

/** Landline: eleven digits, leading 0, area code 1-8 (excludes 09 mobile). */
export const LANDLINE_PHONE = /^0[1-8]\d{9}$/;
export const LANDLINE_PHONE_MESSAGE =
  'تلفن ثابت باید ۱۱ رقم و با کد شهر باشد (مثال: ۰۲۱۱۲۳۴۵۶۷۸)';

/** Postal code: ten digits. */
export const POSTAL_CODE = /^\d{10}$/;
export const POSTAL_CODE_MESSAGE = 'کد پستی باید 10 رقم باشد';

/** Personal کد ملی: ten digits. The checksum is verified by the api. */
export const NATIONAL_ID = /^\d{10}$/;
export const NATIONAL_ID_MESSAGE = 'کد ملی باید 10 رقم باشد';

/** Company شناسه ملی: eleven digits. The checksum is verified by the api. */
export const LEGAL_ID = /^\d{11}$/;
export const LEGAL_ID_MESSAGE = 'شناسه ملی باید 11 رقم باشد';
